/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OrderStatusChanged/view.blocks to change it.
import Content from './Content/index'
import Empty from './Empty/index'
import Error from './Error/index'
import Loading from './Loading/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function OrderStatusChanged({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/OrderStatusChanged"
  
}) {
  return (<React.Fragment
>
<No
  viewPath={`${viewPath}/No`}
/>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
<Empty
  viewPath={`${viewPath}/Empty`}
/>
<Error
  viewPath={`${viewPath}/Error`}
/>
{children}
</React.Fragment>)
}